/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCallListProfile.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/call-list-profile";

export class AutogenModelCallListProfile<RowType extends ModelRow> extends Endpoint<RowType, RowCallListProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCallListProfile extends ModelRow<RowCallListProfileFields> {
	constructor(values?: Partial<RowCallListProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCallListProfileFields {
	act_days: number;
	act_type: string;
	column_to_color: string;
	company_id: string;
	customer_id: string;
	descr: string;
	hierarchy_level_descr: string;
	high_priority_color: string;
	id: string;
	include_opportunities: string;
	include_prospects: string;
	last_order_days: number;
	low_priority_color: string;
	medium_priority_color: string;
	min_value: number;
	min_value_c: string;
	min_value_d: Date;
	min_value_n: number;
	min_value_r: number;
	operations_user: string;
	opportunity_id: string;
	prospect_type_id: string;
	resp_code: string;
	resp_level: number;
	sales_manager_id: string;
	salesperson_id: string;
	status: string;
	type_of: string;
	user_id: string;
	zone_id: string;
}

